import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { useAdvertise } from '@/store/useAdvertise';
import { useStepGuard, buildersStepValid } from '@/utils/advertiseGuards';
import { BUILDERS_STEPS } from '@/config/advertiseSteps';

export default function BuildersContact() {
  const navigate = useNavigate();
  const builders = useAdvertise((s) => s.builders);
  const setField = useAdvertise((s) => s.setField);
  useStepGuard(buildersStepValid.contact(builders), '/advertise/builders');

  const set = (patch) => setField('builders', patch);
  const canProceed = builders.firstName && builders.lastName && builders.email && builders.phone;

  return (
    <AdvertiseLayout
      trackLabel="Community Boost"
      steps={BUILDERS_STEPS}
      currentStepId="contact"
      title="Who should we contact?"
      sidebar={<AdvertiseSideSummary items={[{ label: 'Contact', value: [builders.firstName, builders.lastName].filter(Boolean).join(' ') }, { label: 'Title', value: builders.title }]} />}
      footer={<AdvertiseFooterNav onBack={() => navigate('/advertise/builders/portfolio')} onNext={() => navigate('/advertise/builders/schedule')} nextDisabled={!canProceed} />}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div><Label>First name</Label><Input value={builders.firstName} onChange={(e) => set({ firstName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-contact-first-name" /></div>
        <div><Label>Last name</Label><Input value={builders.lastName} onChange={(e) => set({ lastName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-contact-last-name" /></div>
        <div><Label>Title / role</Label><Input value={builders.title} onChange={(e) => set({ title: e.target.value })} placeholder="VP of Marketing" className="mt-1.5 rounded-xl" data-testid="builders-contact-title" /></div>
        <div><Label>Company email</Label><Input type="email" value={builders.email} onChange={(e) => set({ email: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-contact-email" /></div>
        <div><Label>Phone</Label><Input type="tel" value={builders.phone} onChange={(e) => set({ phone: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-contact-phone" /></div>
        <div><Label>Office ZIP</Label><Input value={builders.zip} onChange={(e) => set({ zip: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-contact-zip" /></div>
      </div>
    </AdvertiseLayout>
  );
}
